import React, { useEffect, useState } from 'react';
import { string, number } from 'prop-types';
import SoundManager from 'utils/SoundManager';
import useUpcomingGameStore from 'stores/upcoming-game';

import { text } from 'polyglot/polyglot';

import styles from './SmallerBanner.module.scss';

const upcomingGameSelector = (state) => state.nextGame;

function SmallerBanner({ background, logoSmall, minutes, seconds, gameId }) {
  const nextGame = useUpcomingGameStore(upcomingGameSelector);
  const [lastPlayedId, setLastPlayedId] = useState('');
  const [nextGameName, setNextGameName] = useState(null);

  useEffect(() => {
    if (minutes === '00' && seconds === '30' && lastPlayedId !== gameId) {
      // Play sound
      SoundManager.instance.playVO('startsoon30');
      setLastPlayedId(gameId);
    }

    // Clean up.
    return () => {
      SoundManager.instance.stopVO('startsoon30');
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [minutes, seconds]);

  useEffect(() => {
    if (nextGame.name && nextGame.name !== nextGameName) {
      setNextGameName(nextGame.name);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nextGame]);

  return (
    <div
      style={{ backgroundImage: `url(${background})` }}
      className={styles.wrapper}
    >
      <img src={`${logoSmall}`} alt="" className={styles.logo} />
      <div className={styles.textWrapper}>
        <span>{text.t('gameBanner.smallBannerTitle')}</span>
        <div className={styles.bold}>
          <span>{nextGame.name}</span>
          {nextGame.startsInSeconds !== -1000 ? (
            <span className={styles.time}>{`${minutes}:${seconds}`}</span>
          ) : (
            <span className={styles.time} />
          )}
        </div>
      </div>
    </div>
  );
}
SmallerBanner.propTypes = {
  background: string.isRequired,
  logoSmall: string.isRequired,
  minutes: string.isRequired,
  seconds: string.isRequired,
  gameId: number.isRequired,
};

export default SmallerBanner;
